import { useEffect, useRef } from 'react';
import { websocketService } from '../services/websocketService';
import { useWebSocket } from '../context/WebSocketContext';

type CitaAction = 'create' | 'update' | 'delete';

export const useWebSocketCitas = (onEvent: (action: CitaAction, citaData: any) => void) => {
    const { onCitaEvent } = useWebSocket();

    useEffect(() => {
        console.log('[useWebSocketCitas] Hook registrado');
        const unsub = onCitaEvent((data) => {
            console.log('[useWebSocketCitas] Evento recibido:', data);
            onEvent(data.action, data.cita);
        });
        
        return () => {
            console.log('[useWebSocketCitas] Hook limpiado');
            unsub();
        };
    }, [onCitaEvent, onEvent]);
};

// One socket shared by all views. Reconnect invalidates snapshots missed offline.
export const useSpaceAvailability = (onEvent: (branchId?: number) => void) => {
    const callback = useRef(onEvent);
    callback.current = onEvent;
    useEffect(() => {
        let timer: ReturnType<typeof setTimeout> | undefined;
        const branches = new Set<number | undefined>();
        const notify = (branchId?: number) => {
            branches.add(branchId);
            clearTimeout(timer);
            timer = setTimeout(() => { callback.current(branches.size === 1 ? Array.from(branches)[0] : undefined); branches.clear(); }, 150);
        };
        const unsubscribe = websocketService.on('espacios_actualizados', data => notify(data.sucursal_id));
        const reconnect = websocketService.onConnectionStatus(connected => { if (connected) notify(); });
        return () => { unsubscribe(); reconnect(); clearTimeout(timer); };
    }, []);
};
